module.exports = __webpack_public_path__ + "img/send-tx-spaceman.c346ef9d.png";